module.exports = __webpack_public_path__ + "static/img/8ec41e3ab32a6d5fd8b512b00949249c42d0e6af2d589-8nj1zo_fw1200@2x.dd1d828.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mine/8ec41e3ab32a6d5fd8b512b00949249c42d0e6af2d589-8nj1zo_fw1200@2x.png
// module id = hqU5
// module chunks = 43